import React from "react";
import { Routes, Route } from "react-router-dom";

import {
  AboutUs,
  Contact,
  Donate,
  ErrorPage,
  Home,
  ProductDetails,
  Cart,
  Checkout,
  Profile,
  Faq,
  PrivacyPolicy,
  Terms,
  OrderNow,
  Supplier,
  Login,
  SignUp,
  Search,
} from "pages";
import { SuperAdminRoutes, ProtectedRoutes } from "./ProtectedRoute";
import {
  AddProduct,
  AddSupplier,
  ChangeDeliveryConfig,
  Dashboard,
  EditProduct,
  EditSuppliers,
  InvoiceGenerate,
  ManageOrders,
  ManageUsers,
  OrderDetails,
  ViewMessages,
  ViewNotifications,
  ViewProducts,
  ViewSupplierDetails,
  ViewSuppliers,
  ViewUser,
} from "dashboard/pages";
import { AppLayout } from "layouts";
import { DashboardLayout } from "dashboard/layouts";
import ChangePassword from "pages/common/ChangePassword";

const PublicRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <AppLayout>
            <Home />
          </AppLayout>
        }
      />
      <Route
        path="/about"
        element={
          <AppLayout>
            <AboutUs />
          </AppLayout>
        }
      />
      <Route
        path="/changepassword"
        element={
          <AppLayout>
            <ChangePassword />
          </AppLayout>
        }
      />
      <Route
        path="/ordernow"
        element={
          <AppLayout>
            <OrderNow />
          </AppLayout>
        }
      />
      <Route
        path="/search"
        element={
          <AppLayout>
            <Search />
          </AppLayout>
        }
      />
      <Route
        path="/supplier/:supplierid"
        element={
          <AppLayout>
            <Supplier />
          </AppLayout>
        }
      />
      <Route
        path="/product/:id"
        element={
          <AppLayout>
            <ProductDetails />
          </AppLayout>
        }
      />

      <Route
        path="/contact"
        element={
          <AppLayout>
            <Contact />
          </AppLayout>
        }
      />
      <Route
        path="/donate"
        element={
          <AppLayout>
            <Donate />
          </AppLayout>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoutes>
            <AppLayout>
              <Profile path={"/"} />
            </AppLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/profile/myorder"
        element={
          <ProtectedRoutes>
            <AppLayout>
              <Profile path={"/myorder"} />
            </AppLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/profile/wishlist"
        element={
          <ProtectedRoutes>
            <AppLayout>
              <Profile path={"/wishlist"} />
            </AppLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/profile/refer"
        element={
          <ProtectedRoutes>
            <AppLayout>
              <Profile path={"/refer"} />
            </AppLayout>
          </ProtectedRoutes>
        }
      />

      <Route
        path="/cart"
        element={
          <ProtectedRoutes>
            <AppLayout>
              <Cart />
            </AppLayout>
          </ProtectedRoutes>
        }
      />

      <Route
        path="/cart/checkout"
        element={
          <ProtectedRoutes>
            <AppLayout>
              <Checkout />
            </AppLayout>
          </ProtectedRoutes>
        }
      />

      <Route
        path="/faq"
        element={
          <AppLayout>
            <Faq />
          </AppLayout>
        }
      />
      <Route
        path="/privacypolicy"
        element={
          <AppLayout>
            <PrivacyPolicy />
          </AppLayout>
        }
      />
      <Route
        path="/terms"
        element={
          <AppLayout>
            <Terms />
          </AppLayout>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="*" element={<ErrorPage />} />
      <Route
        path="/invoices/:id"
        element={
          <ProtectedRoutes>
            <InvoiceGenerate />
          </ProtectedRoutes>
        }
      />
      <Route path="admin">
        <Route
          path="dashboard"
          element={
            <SuperAdminRoutes>
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            </SuperAdminRoutes>
          }
        />
        <Route path="users">
          <Route
            path="manage"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <ManageUsers />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
          <Route
            path="view/:id"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <ViewUser />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
        </Route>
        <Route path="suppliers">
          <Route
            path="view"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <ViewSuppliers />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
          <Route
            path="add"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <AddSupplier />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
          <Route
            path="edit/:id"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <EditSuppliers />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
          <Route
            path="viewdetails/:id"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <ViewSupplierDetails />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
        </Route>
        <Route path="products">
          <Route
            path="view"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <ViewProducts />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
          <Route
            path="edit/:id"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <EditProduct />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
          <Route
            path="add"
            element={
              <SuperAdminRoutes>
                <DashboardLayout>
                  <AddProduct />
                </DashboardLayout>
              </SuperAdminRoutes>
            }
          />
        </Route>
        <Route
          path="orders"
          element={
            <SuperAdminRoutes>
              <DashboardLayout>
                <ManageOrders />
              </DashboardLayout>
            </SuperAdminRoutes>
          }
        />
        <Route
          path="order/:id"
          element={
            <SuperAdminRoutes>
              <DashboardLayout>
                <OrderDetails />
              </DashboardLayout>
            </SuperAdminRoutes>
          }
        />
        <Route
          path="messages"
          element={
            <SuperAdminRoutes>
              <DashboardLayout>
                <ViewMessages />
              </DashboardLayout>
            </SuperAdminRoutes>
          }
        />
        <Route
          path="notifications"
          element={
            <SuperAdminRoutes>
              <DashboardLayout>
                <ViewNotifications />
              </DashboardLayout>
            </SuperAdminRoutes>
          }
        />
        <Route
          path="invoices/:id"
          element={
            <SuperAdminRoutes>
              <DashboardLayout>
                <InvoiceGenerate />
              </DashboardLayout>
            </SuperAdminRoutes>
          }
        />
        <Route
          path="changedeliverytime"
          element={
            <SuperAdminRoutes>
              <DashboardLayout>
                <ChangeDeliveryConfig />
              </DashboardLayout>
            </SuperAdminRoutes>
          }
        />
      </Route>
    </Routes>
  );
};

export default PublicRoutes;
